<template>
  <div class="row">
    <div class="top-bar up-top-bar">
      <div class="up-top-links">
        <div class="up-top-link ml-auto">
          <a @click="updateUser">Save</a>
        </div>
      </div>

      <div class="row">
        <div class="up-top-link-right">
          <router-link :to="`/access-logs?user_id=${user.id}`">&nbsp; Access Logs</router-link>
        </div>
        <div class="up-top-link-right">
          <router-link :to="`/events?user_id=${user.id}`">&nbsp; Log view</router-link>
        </div>
      </div>
      <div class="btn-back ml-auto">
        <a href="#" @click="redirectBack"><i class="fas fa-long-arrow-alt-left"></i> Back</a>
      </div>
      <burger/>
    </div>

    <div>
      <profile-component :user="user" :page="pageName" @update="updatePhoto"></profile-component>
    </div>
  </div>
</template>

<script>
  import ProfileComponent from '@/components/ProfileComponent';
  import Burger from '@/components/Burger';

  export default {
    name: 'MyProfile',
    components: {
      ProfileComponent,
      Burger
    },
    data() {
      return {
        photo: null,
        pageName: 'MyProfile'
      };
    },
    computed: {
      user() {
        return this.$store.state.users.user;
      },
      roles() {
        return this.$store.state.settings.data.user_types;
      },
      currentUserId() {
        return this.$store.state.auth.user_id;
      }
    },
    beforeMount() {
      this.getUser();
    },
    methods: {
      redirectBack() {
        history.go(-1);
      },
      getUser() {
        this.$store.dispatch('users/loadUser', { user_id: this.currentUserId });
      },
      updateUserRole(roleId) {
        this.user.type = roleId;
      },
      updateUser() {
        const data = {
          user_id: parseInt(this.currentUserId),
          fields: ["first_name", "last_name", "mail", "active"],
          values: [this.user.first_name, this.user.last_name, this.user.mail, this.user.active]
        };

        this.$store.dispatch('users/updateUser', data)
          .then(() => {
            this.getUser();
            this.$snotify.success("Profile successfully updated");
            this.updatePassword();
            this.updateUserPhoto();
          })
          .catch(error => this.$snotify.error(error.response.data.message));
      },
      updatePassword() {
        if (this.user.new_key) {
          const data = {
            auth_method: 0,
            new_key: this.user.new_key,
            old_key: this.user.old_key,
            user_id: this.user.id,
          };

          this.$store.dispatch('users/updatePassword', data);
        }
      },
      updatePhoto(photo) {
        this.photo = photo;
      },
      updateUserPhoto() {
        if (this.photo) {
          this.$store.dispatch('users/updatePhoto', { user_id: this.user.id, photo: this.photo })
            .catch(error => this.$snotify.error(error.response.data.error));
        }
      }
    }
  };
</script>

<style scoped>
  .right-container-allert {
    margin-left: 10px;
    height: 93vh;
  }
  .up-top-links {
    width: 405px;
  }
</style>
